module.exports = __webpack_public_path__ + "/images/logo-fr-petit-bateau.0a38ca5.png";